import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { PayItemConnectionGroup, useGroupsContext } from '../../GroupsContext'
import { useRemovePayItemConnectionGroupMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<PayItemConnectionGroup> {
  const { refetch } = useGroupsContext()
  const [remove] = useRemovePayItemConnectionGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemovePayItemConnectionGroup: {
        payItemConnectionGroup: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestorePayItemConnectionGroup,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
